module.exports = __webpack_public_path__ + "img/atlaslist4img3.15e85a67.jpg";